export const GENERATE_DISPLAY_MODEL = 'renderCache/GENERATE';
export const PROCESSING_DISPLAY_MODEL = 'renderCache/PROCESS';
export const CACHE_DISPLAY_MODEL = 'renderCache/CACHE';
export const INVALIDATE_CACHE = 'renderCache/INVALIDATE';
